import trySaveAndCloseCompose from '../actions/trySaveAndCloseCompose';
import upConvert from '../actions/upConvert';
import { getStore } from 'owa-mail-compose-store';
import { TabHandler, ComposeTabViewState, TabType, registerTabHandler } from 'owa-tab-store';

const composeTabHandler: TabHandler = {
    onActivate: (viewState: ComposeTabViewState) => {
        const store = getStore();
        const composeViewState = store.viewStates.get(viewState.data);
        if (composeViewState.isInlineCompose) {
            upConvert(composeViewState);
        }
    },

    canClose: async (viewState: ComposeTabViewState) => {
        const store = getStore();
        const composeViewState = store.viewStates.get(viewState.data);
        await trySaveAndCloseCompose(composeViewState);
        // Always return false since trySaveAndCloseCompose() will close compose if it can
        return false;
    },
};

export default function ensureComposeTabHandler() {
    registerTabHandler(TabType.Compose, composeTabHandler);
}
